import { render } from "./DownloadPdf.vue?vue&type=template&id=ded4afd8"
import script from "./DownloadPdf.vue?vue&type=script&lang=js"
export * from "./DownloadPdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__